import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './button';
import { useThemeMode } from '../../react-app/theme/ThemeProvider';

interface ThemeToggleProps {
  size?: 'sm' | 'lg' | 'icon' | 'default';
  variant?: 'ghost' | 'outline' | 'default';
  showLabel?: boolean;
  testId?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  size = 'sm',
  variant = 'ghost',
  showLabel = false,
  testId,
}) => {
  const { mode, toggle } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Button
      variant={variant}
      size={size}
      data-testid={testId}
      onClick={toggle}
      className="flex items-center gap-2"
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
      {showLabel && (
        <span className="text-sm">
          {isDark ? 'Light' : 'Dark'}
        </span>
      )}
    </Button>
  );
};
